<template>
  <div class="login">
    <div class="loginForm">
      <h1 class="title">供应商系统</h1>

      <span class="icon">
        <Icon type="ios-person"></Icon>

      </span>
      <div
        class="title"
        style="margin: 10px;"
      >v1.0.401</div>
      <Form
        ref="loginForm"
        :model="login"
        :rules="rules"
        class="login-form"
      >
        <FormItem prop="loginCode">
          <Input
            type="text"
            style="width:360px"
            v-model="login.loginCode"
            placeholder="请输入登录账号"
          >
          <Icon
            type="ios-person-outline"
            slot="prepend"
          />
          </Input>
        </FormItem>
        <FormItem prop="loginPwd">
          <Input
            type="password"
            style="width:360px"
            v-model="login.loginPwd"
            placeholder="请输入密码"
          >
          <Icon
            type="ios-lock-outline"
            slot="prepend"
          />
          </Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            long
            @click="handleSubmit"
          >登录</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import {supplierLoginRule} from '@/plugin/validateRule'
import {touchSessionActivity} from '@/plugin/callApi'

export default {
  name: 'Login',
  data () {
    return {
      login: {
        loginCode: '',
        loginPwd: ''
      },
      rules: supplierLoginRule
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.loginForm.validate((valid) => {
        if(valid) {
          this.$fetch('uploading/login',this.login).then(res => {
            sessionStorage.setItem('userData',JSON.stringify(res.data))
            touchSessionActivity()
            this.$Message.success({
              content: '登录成功',
              onClose: () => {
                if(res.data.type === 'sys') {
                  this.$router.replace('/material/index')
                }else if (res.data.type === 'cus') {
                  this.$router.replace('/supplier/index')
                }
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './login.less';
</style>
